import React from 'react'

import Auth from '../../../../../containers/Auth'
import { GameWithUserInformation } from '../../../../../containers/GamesBlock/types'
import LoggedInButtons from './LoggedInButtons'
import LoggedOutButtons from './LoggedOutButtons'

interface Props {
  game: GameWithUserInformation
  small?: boolean
}

function DesktopButtons({ game, small }: Props) {
  return (
    <Auth
      renderLoggedIn={() => (
        <LoggedInButtons
          forFunPlayUrl={game.forFunPlayUrl}
          realPlayUrl={game.realPlayUrl}
          small={small}
        />
      )}
      renderLoggedOut={() => (
        <LoggedOutButtons
          forFunPlayUrl={game.forFunPlayUrl}
          realPlayUrl={game.realPlayUrl}
          small={small}
        />
      )}
    />
  )
}

export default DesktopButtons
